var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    stroke: "#510C76",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.184 20.998a7.468 7.468 0 0 1 1.825-4.644 3.485 3.485 0 0 0-4.875-.758 5.757 5.757 0 0 0 3.05 5.402zM20.232 20.998a7.469 7.469 0 0 0-1.826-4.644 3.485 3.485 0 0 1 4.875-.758 5.757 5.757 0 0 1-3.05 5.402z",
    fill: "#E8DEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18 21.262a7.5 7.5 0 1 1 15 0",
    stroke: "{stroke}",
    strokeWidth: 0.828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.32 16.354a3.485 3.485 0 0 1 5.143-.542",
    stroke: "{stroke}",
    strokeWidth: 0.828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.139 13.064a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652z",
    fill: "#E8DEF1",
    stroke: "{stroke}",
    strokeWidth: 0.828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01 16.354a3.485 3.485 0 0 0-5.143-.542",
    stroke: "{stroke}",
    strokeWidth: 0.828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.193 13.064a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652z",
    fill: "#E8DEF1",
    stroke: "{stroke}",
    strokeWidth: 0.828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.674 11.784a4.65 4.65 0 1 0 0-9.301 4.65 4.65 0 0 0 0 9.301z",
    stroke: "{stroke}",
    strokeWidth: 0.828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e1476d4729423c4cc7c5c75625e6c9df.svg";
export { ForwardRef as ReactComponent };